export default {
  tags: {
    preferred: 'Voorkeur',
  },
};
